const PREFIX = '/v1/CollectiveProject/CollectiveOwnedProjectCapitalExamineService'

export const URL = {
  ADD: PREFIX + '/add',
  DEL: PREFIX + '/delete',
  EDIT: PREFIX + '/edit',
  LIST: PREFIX + '/list',
  DETAIL: PREFIX + '/view',
  ENABLE: PREFIX + '/able',
  DISABLE: PREFIX + '/disable',
  ORDER: PREFIX + '/order',
  REVIEW_LIST: PREFIX + '/shenHeList',
  USER_FILE_TPL: PREFIX + '/capitalExamineNameListFileImportTemplete',
  USER_FILE_PREVIEW: PREFIX + '/capitalExamineNameListFilesView'
}
